import { SEARCH_SEARCH_BOOKSETS_SET_DATA } from 'rebook/apps/search/constants';


const initialState = {
  booksetList: null,
  booksetsCount: null,
  query: null,
  pageNumber: 1,
  lastPageNumber: 1,
  isLoading: true,
};

export default function searchBooks(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SEARCH_BOOKSETS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
